import { useState } from "react"

export const SpeakerState = () => {
    const [speakerList, setSpeakerList] = useState([])
    const [ isLoading ,setIsLoading ] = useState(false);
    const [ isModal ,setIsModal ] = useState({open: false, mode:''});
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorID, setAnchorID] = useState(null);
    const [checked, setChecked] = useState(null);
    const [ isForm ,setIsForm ] = useState(
        {
            id:'',
            first_name: '',
            last_name: '',
            profession: '',
            license: '',
            expiry_date: '',
            type:'',
            active: 1,
        }
    );
    const [ isValidation ,setIsValidation ] = useState(
        {
            first_name: false,
            last_name: false,
            // profession: false,
            type: false,
            license: false,
            expiry_date: false,
            active: false,
        }
    );
    const [isOpen, setIsOpen] = useState(false);
    const [sloader, setSloader] = useState(false);

    return {
        isOpen: {data: isOpen, set: setIsOpen},
        sloader: {data: sloader, set: setSloader},
        slist: {data: speakerList, set: setSpeakerList},
        isLoading: {data: isLoading, set: setIsLoading},
        isModal: {data: isModal, set: setIsModal},
        anchorEl: {data: anchorEl, set: setAnchorEl},
        anchorID: {data: anchorID, set: setAnchorID},
        checked: {data: checked, set: setChecked},
        isForm: {data: isForm, set: setIsForm},
        isValidation: {data: isValidation, set: setIsValidation},
    }
}
export const ProviderState = () => {
    const [providerList, setProviderList] = useState(null)
    const [ isLoading ,setIsLoading ] = useState(false);
    const [ isModal ,setIsModal ] = useState({open: false, mode:''});
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorID, setAnchorID] = useState(null);
    const [checked, setChecked] = useState(null);
    const [ isForm ,setIsForm ] = useState(
        {
            accreditation_num: '',
            accreditation_date: '',
            expiry_date:'',
            name:'',
            company_id:'',
            id:'',
        }
    );
    const [ isValidation ,setIsValidation ] = useState(
        {
            accreditation_num: false,
            accreditation_date: false,
            expiry_date:false,
        }
    );
    const [open, setOpen] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [sloader, setSloader] = useState(false);

    const [provinces, setProvinces] = useState([]);
    const [cities, setCities] = useState([]);
    const [barangays, setBarangays] = useState([]);
    const [ imageUpload , setImageUpload] = useState(false);

    return {
        plist: {data: providerList, set: setProviderList},
        open: {data: open, set: setOpen},
        isOpen: {data: isOpen, set: setIsOpen},
        sloader: {data: sloader, set: setSloader},
        isLoading: {data: isLoading, set: setIsLoading},
        isModal: {data: isModal, set: setIsModal},
        anchorEl: {data: anchorEl, set: setAnchorEl},
        anchorID: {data: anchorID, set: setAnchorID},
        checked: {data: checked, set: setChecked},
        isForm: {data: isForm, set: setIsForm},
        isValidation: {data: isValidation, set: setIsValidation},
        provinces: {data: provinces, set: setProvinces},
        cities: {data: cities, set: setCities},
        barangays: {data: barangays, set: setBarangays},
        imageUpload: {data: imageUpload, set: setImageUpload},
    }
}